module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzAxIiBoZWlnaHQ9IjIwNSIgdmlld0JveD0iMCAwIDMwMSAyMDUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgZmlsbC1ydWxlPSJub256ZXJvIiBmaWxsPSJub25lIj48cGF0aCBmaWxsPSIjMDA3OTM0IiBkPSJNLjUuMjI3aDMwMHYyMDQuNTQ1SC41eiIvPjxwYXRoIGZpbGw9IiNGOUUzMDAiIGQ9Ik0uNS4yMjdoMzAwdjEzNi4zNjRILjV6Ii8+PHBhdGggZmlsbD0iI0Q1MkIxRSIgZD0iTS41LjIyN2gzMDB2NjguMTgySC41eiIvPjwvZz48L3N2Zz4="


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/svg/flag/cif-bo.svg
// module id = Lh2W
// module chunks = 2